import { message } from "antd";
import {
  ADMIN_ADD_BATCH_REQUEST,
  ADMIN_ADD_BATCH_SUCCESS,
  ADMIN_ADD_BATCH_FAIL,
  ADMIN_GET_BATCH_REQUEST,
  ADMIN_GET_BATCH_SUCCESS,
  ADMIN_GET_BATCH_FAIL,
  ADMIN_UPDATE_BATCH_REQUEST,
  ADMIN_UPDATE_BATCH_SUCCESS,
  ADMIN_UPDATE_BATCH_FAIL,
  ADMIN_DELETE_BATCH_REQUEST,
  ADMIN_DELETE_BATCH_SUCCESS,
  ADMIN_DELETE_BATCH_FAIL,
  CLEAR_ERRORS,
} from "../../constants/admin/batchConstants";
import axios from "../../../axiosInstance";

// Add Batch
export const addBatch = (batchData) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_ADD_BATCH_REQUEST });

    const { data } = await axios.post(
      "/api/v1/batch/admin-add-batch",
      batchData
    );

    dispatch({
      type: ADMIN_ADD_BATCH_SUCCESS,
      payload: data,
    });
    if (data?.success === true) {
      dispatch({ type: ADMIN_ADD_BATCH_SUCCESS, payload: data });
      message.success(
        data?.message || "Batch & Class Added Successfully"
      );
    } else {
      throw new Error(data?.message || "Failed to Added batch & class");
    }
  } catch (error) {
    dispatch({
      type: ADMIN_ADD_BATCH_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    message.error(
      error?.response?.data?.message || "Failed to Added batch & class"
    );
  }
};

// Get Batch
export const getBatch = () => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_GET_BATCH_REQUEST });

    const { data } = await axios.get("/api/v1/batch/admin-get-batch");

    dispatch({
      type: ADMIN_GET_BATCH_SUCCESS,
      payload: data.batch,
    });
  } catch (error) {
    dispatch({
      type: ADMIN_GET_BATCH_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Update Batch
export const updateBatch = (id, batchData) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_UPDATE_BATCH_REQUEST });

    const { data } = await axios.put(`/api/v1/batch/admin-update-batch`, {
      id,
      batchData,
    });
    if (data?.success === true) {
      dispatch({ type: ADMIN_UPDATE_BATCH_SUCCESS, payload: data });
      message.success(data?.message || "Batch & Class details updated successfully");
    } else {
      throw new Error(data?.message || "Failed to updated batch & class");
    }
  } catch (error) {
    dispatch({
      type: ADMIN_UPDATE_BATCH_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    message.error(error?.response?.data?.message || "Failed to update batch & class");
  }
};

// Delete Batch
export const deleteBatch = (id) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_DELETE_BATCH_REQUEST });

    const response = await axios.delete(`/api/v1/batch/admin-delete-batch`, {
      data: { id },
    });
    if (response?.data?.success === true) {
      dispatch({ type: ADMIN_DELETE_BATCH_SUCCESS, payload: id });
      message.success(response?.data?.message || "Batch & Class deleted successfully");
    } else {
      throw new Error(response?.data?.message || "Failed to delete batch & class");
    }
  } catch (error) {
    dispatch({
      type: ADMIN_DELETE_BATCH_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    message.error(error?.response?.data?.message || "Failed to delete batch & class");
  }
};

// Clearing Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
